import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import PreCheckAction from './testComponents/preChecks/PreCheckAction';
import TestComponentWrapper from './TestComponent';
import TestComponentPreChecks from './testComponents/preChecks/TestComponentPreChecks';
import TestComponentsDoneBox from './TestComponentsDoneBox';
import parentTestService from '../../services/ParentTestService';
import TestComponentsSelector from '../../services/testOverview/TestComponentsSelector';
import WaitingRoom from '../remoteOralExam/WaitingRoom';

// function component compliant with the Rules of Hooks.
const UseEffectCountdown = () => {
    useEffect(() => {
        parentTestService.startStartTimeCountdown();
        return () => {
            parentTestService.stopParentTestIntervals();
        };
    }, []);

    return null;
};

export class PureTestComponents extends React.PureComponent {
    static propTypes = {
        allShownChecksCompleted: PropTypes.bool.isRequired,
        cacheStatus: PropTypes.object.isRequired,
        idverification: PropTypes.object.isRequired,
        livestream: PropTypes.object.isRequired,
        navigationLock: PropTypes.object.isRequired,
        offlineFileDeliveryStatus: PropTypes.object,
        parentTest: PropTypes.object.isRequired,
        pendingAssessments: PropTypes.object.isRequired,
        remoteOralExam: PropTypes.object,
        standaloneTest: PropTypes.object,
        timeHasExpired: PropTypes.bool.isRequired,

        // resolved
        allChildTestsFinished: PropTypes.bool.isRequired,
        childTests: PropTypes.array.isRequired,
        isReadinessCheckComplete: PropTypes.bool.isRequired,
        readinessCheckProps: PropTypes.object,
        remoteOralCandidateJoined: PropTypes.bool.isRequired,
        remoteOralInProgress: PropTypes.bool.isRequired,
        shouldShowPreChecks: PropTypes.bool.isRequired,
        shouldUseCountdown: PropTypes.bool.isRequired,
        showComponentsDoneBox: PropTypes.bool.isRequired,
        showRemoteOral: PropTypes.bool.isRequired,
        showStandaloneLiveSessionTest: PropTypes.bool.isRequired,
        standaloneTestCacheStatus: PropTypes.object,
    };

    getPreChecksComponent = () => {
        const {
            allShownChecksCompleted,
            readinessCheckProps,
            shouldShowPreChecks,
            isReadinessCheckComplete,
        } = this.props;

        let preChecksComponent = null;
        if (shouldShowPreChecks) {
            if (readinessCheckProps) {
                const readinessCheckComponent = (
                    <PreCheckAction
                        current={!isReadinessCheckComplete}
                        completed={isReadinessCheckComplete}
                        failed={false}
                        title={readinessCheckProps.test.title}
                    >
                        <TestComponentWrapper
                            {...readinessCheckProps}
                        />
                    </PreCheckAction>
                );

                preChecksComponent = (
                    <TestComponentPreChecks
                        readinessCheckComponent={readinessCheckComponent}
                        isReadinessCheckComplete={isReadinessCheckComplete}
                        allShownChecksCompleted={allShownChecksCompleted}
                    />
                );
            } else {
                preChecksComponent = <TestComponentPreChecks allShownChecksCompleted={allShownChecksCompleted} />;
            }
        }
        return preChecksComponent;
    }

    render() {
        const {
            allChildTestsFinished,
            allShownChecksCompleted,
            cacheStatus,
            childTests,
            idverification,
            livestream,
            navigationLock,
            offlineFileDeliveryStatus,
            parentTest,
            pendingAssessments,
            remoteOralCandidateJoined,
            remoteOralExam,
            remoteOralInProgress,
            shouldUseCountdown,
            showComponentsDoneBox,
            showRemoteOral,
            showStandaloneLiveSessionTest,
            standaloneTest,
            standaloneTestCacheStatus,
        } = this.props;

        return (
            <React.Fragment>
                { shouldUseCountdown && <UseEffectCountdown /> }
                { this.getPreChecksComponent() }
                { showStandaloneLiveSessionTest &&
                    <TestComponentWrapper
                        cacheStatus={standaloneTestCacheStatus}
                        test={standaloneTest}
                        parentTest={standaloneTest}
                        offlineFileDeliveryStatus={{}}
                        key={standaloneTest.assessmentRunId}
                        isCompleted={false}
                        navigationLock={navigationLock}
                        pendingAssessments={pendingAssessments}
                        livestream={livestream}
                        idverification={idverification}
                    /> }

                { childTests.map(test => (
                    <TestComponentWrapper
                        cacheStatus={cacheStatus[test.assessmentRunId] || {}}
                        test={test}
                        parentTest={parentTest}
                        offlineFileDeliveryStatus={offlineFileDeliveryStatus}
                        key={test.assessmentRunId}
                        isCompleted={parentTestService.isChildTestCompleted(test, offlineFileDeliveryStatus)}
                        navigationLock={navigationLock}
                        pendingAssessments={pendingAssessments}
                        livestream={livestream}
                        idverification={idverification}
                    />
                ))}

                { showRemoteOral && <WaitingRoom
                    isCandidateJoined={remoteOralCandidateJoined}
                    isInProgress={remoteOralInProgress}
                    allShownChecksCompleted={allShownChecksCompleted}
                    status={remoteOralExam.waitingRoom}
                /> }

                { showComponentsDoneBox &&
                    <TestComponentsDoneBox
                        allChildTestsFinished={allChildTestsFinished}
                    /> }

            </React.Fragment>
        );
    }
}

const TestComponents = (ownProps) => {
    const resolvedProps = TestComponentsSelector.mapToProps(ownProps);
    return <PureTestComponents {...ownProps} {...resolvedProps} />;
};

export default TestComponents;
